import {useCallback, useMemo} from 'react';

interface UseLocalStorageType {
  getItem: () => string | null;
  setItem: (value: string) => void;
  removeItem: () => void;
}

export function useLocalStorage(key: string): UseLocalStorageType {
  const storageKey = useMemo(() => key, [key]);

  const getItem = useCallback(
    () => localStorage.getItem(storageKey),
    [storageKey],
  );

  const setItem = useCallback(
    (value: string) => localStorage.setItem(storageKey, value),
    [storageKey],
  );

  const removeItem = useCallback(
    () => localStorage.removeItem(storageKey),
    [storageKey],
  );

  return {getItem, setItem, removeItem};
}
